/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Node } from '../core/models/Node';
import { AuthorizationCodeOAuthFlow } from '../core/models/common/AuthorizationCodeOAuthFlow';
import { ClientCredentialsOAuthFlow } from '../core/models/common/ClientCredentialsOAuthFlow';
import { Components } from '../core/models/common/Components';
import { IDefinition } from '../core/models/common/IDefinition';
import { IExample } from '../core/models/common/IExample';
import { IPropertySchema } from '../core/models/common/IPropertySchema';
import { ImplicitOAuthFlow } from '../core/models/common/ImplicitOAuthFlow';
import { OAuthFlows } from '../core/models/common/OAuthFlows';
import { Operation } from '../core/models/common/Operation';
import { Parameter } from '../core/models/common/Parameter';
import { PasswordOAuthFlow } from '../core/models/common/PasswordOAuthFlow';
import { Schema } from '../core/models/common/Schema';
import { SecurityRequirement } from '../core/models/common/SecurityRequirement';
import { SecurityScheme } from '../core/models/common/SecurityScheme';
import { Server } from '../core/models/common/Server';
import { ServerVariable } from '../core/models/common/ServerVariable';
import { OasDocument } from '../openapi/models/OasDocument';
import { OasHeader } from '../openapi/models/OasHeader';
import { OasPathItem } from '../openapi/models/OasPathItem';
import { OasPaths } from '../openapi/models/OasPaths';
import { OasResponse } from '../openapi/models/OasResponse';
import { OasResponses } from '../openapi/models/OasResponses';
import { OasSchema } from '../openapi/models/OasSchema';
import { OasXML } from '../openapi/models/OasXML';
import { Oas30Callback } from '../openapi/v3/models/Oas30Callback';
import { Oas30CallbackDefinition } from '../openapi/v3/models/Oas30CallbackDefinition';
import { Oas30CallbackPathItem } from '../openapi/v3/models/Oas30CallbackPathItem';
import { Oas30Discriminator } from '../openapi/v3/models/Oas30Discriminator';
import { Oas30Document } from '../openapi/v3/models/Oas30Document';
import { Oas30Encoding } from '../openapi/v3/models/Oas30Encoding';
import { Oas30Example } from '../openapi/v3/models/Oas30Example';
import { Oas30ExampleDefinition } from '../openapi/v3/models/Oas30ExampleDefinition';
import { Oas30HeaderDefinition } from '../openapi/v3/models/Oas30HeaderDefinition';
import { Oas30Link } from '../openapi/v3/models/Oas30Link';
import { Oas30LinkDefinition } from '../openapi/v3/models/Oas30LinkDefinition';
import { Oas30LinkParameterExpression } from '../openapi/v3/models/Oas30LinkParameterExpression';
import { Oas30LinkRequestBodyExpression } from '../openapi/v3/models/Oas30LinkRequestBodyExpression';
import { Oas30LinkServer } from '../openapi/v3/models/Oas30LinkServer';
import { Oas30MediaType } from '../openapi/v3/models/Oas30MediaType';
import { Oas30Operation } from '../openapi/v3/models/Oas30Operation';
import { Oas30RequestBody } from '../openapi/v3/models/Oas30RequestBody';
import { Oas30RequestBodyDefinition } from '../openapi/v3/models/Oas30RequestBodyDefinition';
import { Oas30Response } from '../openapi/v3/models/Oas30Response';
import { Oas30ResponseDefinition } from '../openapi/v3/models/Oas30ResponseDefinition';
import { IOas30Visitor } from '../openapi/v3/visitors/IOas30Visitor';
import { ModelClonerVisitor } from './ModelClonerVisitor';
import { Document } from '../core/models/Document';
import { OasOperation } from '../openapi/models/OasOperation';
import { OasParameter } from '../openapi/models/OasParameter';
import { Oas30Header } from '../openapi/v3/models/Oas30Header';
import { Oas30Components } from '../openapi/v3/models/Oas30Components';
import { Oas30ParameterDefinition } from '../openapi/v3/models/Oas30ParameterDefinition';
import { Oas30SchemaDefinition } from '../openapi/v3/models/Oas30SchemaDefinition';
import { OasSecurityRequirement } from '../openapi/models/OasSecurityRequirement';
import { Oas30SecurityScheme } from '../openapi/v3/models/Oas30SecurityScheme';
import { Oas30Schema } from '../openapi/v3/models/Oas30Schema';

/**
 * TODO: create model factories for OpenAPI (already exists for AsyncAPI) to make this easier
 * 
 * @author eric.wittmann@gmail.com
 * @class
 * @extends ModelClonerVisitor
 */
export class Oas30ModelClonerVisitor extends ModelClonerVisitor implements IOas30Visitor {
    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitPaths(io.apicurio.datamodels.openapi.models.OasPaths)
     * @param {OasPaths} node
     */
    public visitPaths(node : OasPaths) {
        this.__clone = (<OasDocument>node.ownerDocument()).createPaths();
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitPathItem(io.apicurio.datamodels.openapi.models.OasPathItem)
     * @param {OasPathItem} node
     */
    public visitPathItem(node : OasPathItem) {
        this.__clone = (<OasDocument>node.ownerDocument()).createPaths().createPathItem(node.getPath());
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitResponse(io.apicurio.datamodels.openapi.models.OasResponse)
     * @param {OasResponse} node
     */
    public visitResponse(node : OasResponse) {
        this.__clone = (<OasDocument>node.ownerDocument()).createPaths().createPathItem("").createOperation(null).createResponses().createResponse(node.getStatusCode());
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitResponses(io.apicurio.datamodels.openapi.models.OasResponses)
     * @param {OasResponses} node
     */
    public visitResponses(node : OasResponses) {
        this.__clone = (<OasDocument>node.ownerDocument()).createPaths().createPathItem("").createOperation(null).createResponses();
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitXML(io.apicurio.datamodels.openapi.models.OasXML)
     * @param {OasXML} node
     */
    public visitXML(node : OasXML) {
        this.__clone = (<OasSchema>(<OasDocument>node.ownerDocument()).createPaths().createPathItem("").createOperation(null).createParameter().createSchema()).createXML();
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitAllOfSchema(io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasSchema} node
     */
    public visitAllOfSchema(node : OasSchema) {
        this.__clone = node.createAllOfSchema();
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitItemsSchema(io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasSchema} node
     */
    public visitItemsSchema(node : OasSchema) {
        this.__clone = (<OasSchema>(<OasDocument>node.ownerDocument()).createPaths().createPathItem("").createOperation(null).createParameter().createSchema()).createItemsSchema();
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitAdditionalPropertiesSchema(io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasSchema} node
     */
    public visitAdditionalPropertiesSchema(node : OasSchema) {
        this.__clone = (<OasSchema>(<OasDocument>node.ownerDocument()).createPaths().createPathItem("").createOperation(null).createParameter().createSchema()).createAdditionalPropertiesSchema();
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitPropertySchema(io.apicurio.datamodels.core.models.common.IPropertySchema)
     * @param {*} node
     */
    public visitPropertySchema(node : IPropertySchema) {
        this.__clone = (<OasSchema>(<OasDocument>(<Node><any>node).ownerDocument()).createPaths().createPathItem("").createOperation(null).createParameter().createSchema()).createPropertySchema(node.getPropertyName());
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitHeader(io.apicurio.datamodels.openapi.models.OasHeader)
     * @param {OasHeader} node
     */
    public visitHeader(node : OasHeader) {
        this.__clone = (<Oas30Response>(<OasDocument>node.ownerDocument()).createPaths().createPathItem("").createOperation(null).createResponses().createDefaultResponse()).createHeader(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitResponseDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitResponseDefinition(node : IDefinition) {
        this.__clone = <Oas30ResponseDefinition>(<Oas30Document>(<Node><any>node).ownerDocument()).createComponents().createResponseDefinition(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitExample(io.apicurio.datamodels.core.models.common.IExample)
     * @param {*} node
     */
    public visitExample(node : IExample) {
        this.__clone = ((<Oas30Document>(<Node><any>node).ownerDocument()).createComponents().createParameterDefinition("").createExample((<Oas30Example><any>node).getName()));
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitOperation(io.apicurio.datamodels.core.models.common.Operation)
     * @param {Operation} node
     */
    public visitOperation(node : Operation) {
        this.__clone = (<OasDocument>node.ownerDocument()).createPaths().createPathItem("").createOperation(node.getType());
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitParameterDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitParameterDefinition(node : IDefinition) {
        this.__clone = (<Oas30Document>(<Node><any>node).ownerDocument()).createComponents().createParameterDefinition(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitParameter(io.apicurio.datamodels.core.models.common.Parameter)
     * @param {Parameter} node
     */
    public visitParameter(node : Parameter) {
        this.__clone = (<OasDocument>node.ownerDocument()).createPaths().createPathItem("").createParameter();
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSchemaDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitSchemaDefinition(node : IDefinition) {
        this.__clone = (<Oas30Document>(<Node><any>node).ownerDocument()).createComponents().createSchemaDefinition(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSchema(io.apicurio.datamodels.core.models.common.Schema)
     * @param {Schema} node
     */
    public visitSchema(node : Schema) {
        this.__clone = (<OasDocument>node.ownerDocument()).createPaths().createPathItem("").createParameter().createSchema();
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSecurityRequirement(io.apicurio.datamodels.core.models.common.SecurityRequirement)
     * @param {SecurityRequirement} node
     */
    public visitSecurityRequirement(node : SecurityRequirement) {
        this.__clone = (<OasDocument>node.ownerDocument()).createSecurityRequirement();
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSecurityScheme(io.apicurio.datamodels.core.models.common.SecurityScheme)
     * @param {SecurityScheme} node
     */
    public visitSecurityScheme(node : SecurityScheme) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createSecurityScheme(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitComponents(io.apicurio.datamodels.core.models.common.Components)
     * @param {Components} node
     */
    public visitComponents(node : Components) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents();
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitCallbackPathItem(io.apicurio.datamodels.openapi.v3.models.Oas30CallbackPathItem)
     * @param {Oas30CallbackPathItem} node
     */
    public visitCallbackPathItem(node : Oas30CallbackPathItem) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createCallbackDefinition("").createPathItem(node.getPath());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitCallback(io.apicurio.datamodels.openapi.v3.models.Oas30Callback)
     * @param {Oas30Callback} node
     */
    public visitCallback(node : Oas30Callback) {
        this.__clone = (<Oas30Operation>(<OasDocument>((<Node>node).ownerDocument())).createPaths().createPathItem("/").createOperation("GET")).createCallback(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkServer(io.apicurio.datamodels.openapi.v3.models.Oas30LinkServer)
     * @param {Oas30LinkServer} node
     */
    public visitLinkServer(node : Oas30LinkServer) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createLinkDefinition("").createServer();
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitCallbackDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30CallbackDefinition)
     * @param {Oas30CallbackDefinition} node
     */
    public visitCallbackDefinition(node : Oas30CallbackDefinition) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createCallbackDefinition(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLink(io.apicurio.datamodels.openapi.v3.models.Oas30Link)
     * @param {Oas30Link} node
     */
    public visitLink(node : Oas30Link) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createResponseDefinition("").createLink(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkRequestBodyExpression(io.apicurio.datamodels.openapi.v3.models.Oas30LinkRequestBodyExpression)
     * @param {Oas30LinkRequestBodyExpression} node
     */
    public visitLinkRequestBodyExpression(node : Oas30LinkRequestBodyExpression) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createLinkDefinition("").createLinkRequestBodyExpression(node.getValue());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkParameterExpression(io.apicurio.datamodels.openapi.v3.models.Oas30LinkParameterExpression)
     * @param {Oas30LinkParameterExpression} node
     */
    public visitLinkParameterExpression(node : Oas30LinkParameterExpression) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createLinkDefinition("").createLinkParameterExpression(node.getName(), node.getValue());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30LinkDefinition)
     * @param {Oas30LinkDefinition} node
     */
    public visitLinkDefinition(node : Oas30LinkDefinition) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createLinkDefinition(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitAuthorizationCodeOAuthFlow(io.apicurio.datamodels.core.models.common.AuthorizationCodeOAuthFlow)
     * @param {AuthorizationCodeOAuthFlow} node
     */
    public visitAuthorizationCodeOAuthFlow(node : AuthorizationCodeOAuthFlow) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createSecurityScheme("").createOAuthFlows().createAuthorizationCodeOAuthFlow();
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitClientCredentialsOAuthFlow(io.apicurio.datamodels.core.models.common.ClientCredentialsOAuthFlow)
     * @param {ClientCredentialsOAuthFlow} node
     */
    public visitClientCredentialsOAuthFlow(node : ClientCredentialsOAuthFlow) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createSecurityScheme("").createOAuthFlows().createClientCredentialsOAuthFlow();
    }

    /**
     * 
     * @param {PasswordOAuthFlow} node
     */
    public visitPasswordOAuthFlow(node : PasswordOAuthFlow) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createSecurityScheme("").createOAuthFlows().createPasswordOAuthFlow();
    }

    /**
     * 
     * @param {ImplicitOAuthFlow} node
     */
    public visitImplicitOAuthFlow(node : ImplicitOAuthFlow) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createSecurityScheme("").createOAuthFlows().createImplicitOAuthFlow();
    }

    /**
     * 
     * @param {OAuthFlows} node
     */
    public visitOAuthFlows(node : OAuthFlows) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createSecurityScheme("").createOAuthFlows();
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitEncoding(io.apicurio.datamodels.openapi.v3.models.Oas30Encoding)
     * @param {Oas30Encoding} node
     */
    public visitEncoding(node : Oas30Encoding) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createRequestBodyDefinition("").createMediaType("").createEncoding(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitMediaType(io.apicurio.datamodels.openapi.v3.models.Oas30MediaType)
     * @param {Oas30MediaType} node
     */
    public visitMediaType(node : Oas30MediaType) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createRequestBodyDefinition("").createMediaType(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitHeaderDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30HeaderDefinition)
     * @param {Oas30HeaderDefinition} node
     */
    public visitHeaderDefinition(node : Oas30HeaderDefinition) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createHeaderDefinition(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitRequestBody(io.apicurio.datamodels.openapi.v3.models.Oas30RequestBody)
     * @param {Oas30RequestBody} node
     */
    public visitRequestBody(node : Oas30RequestBody) {
        this.__clone = (<Oas30Operation>(<OasDocument>node.ownerDocument()).createPaths().createPathItem("").createOperation("GET")).createRequestBody();
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitRequestBodyDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30RequestBodyDefinition)
     * @param {Oas30RequestBodyDefinition} node
     */
    public visitRequestBodyDefinition(node : Oas30RequestBodyDefinition) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createRequestBodyDefinition(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitExampleDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30ExampleDefinition)
     * @param {Oas30ExampleDefinition} node
     */
    public visitExampleDefinition(node : Oas30ExampleDefinition) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createExampleDefinition(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitDiscriminator(io.apicurio.datamodels.openapi.v3.models.Oas30Discriminator)
     * @param {Oas30Discriminator} node
     */
    public visitDiscriminator(node : Oas30Discriminator) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createSchemaDefinition("").createDiscriminator();
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitNotSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30NotSchema)
     * @param {Oas30Schema.Oas30NotSchema} node
     */
    public visitNotSchema(node : Oas30Schema.Oas30NotSchema) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createSchemaDefinition("").createNotSchema();
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitOneOfSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30OneOfSchema)
     * @param {Oas30Schema.Oas30OneOfSchema} node
     */
    public visitOneOfSchema(node : Oas30Schema.Oas30OneOfSchema) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createSchemaDefinition("").createOneOfSchema();
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitAnyOfSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30AnyOfSchema)
     * @param {Oas30Schema.Oas30AnyOfSchema} node
     */
    public visitAnyOfSchema(node : Oas30Schema.Oas30AnyOfSchema) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createComponents().createSchemaDefinition("").createAnyOfSchema();
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitServer(io.apicurio.datamodels.core.models.common.Server)
     * @param {Server} node
     */
    public visitServer(node : Server) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createServer();
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitServerVariable(io.apicurio.datamodels.core.models.common.ServerVariable)
     * @param {ServerVariable} node
     */
    public visitServerVariable(node : ServerVariable) {
        this.__clone = (<Oas30Document>(<Node>node).ownerDocument()).createServer().createServerVariable(node.getName());
    }

    constructor() {
        super();
    }
}
Oas30ModelClonerVisitor["__class"] = "io.apicurio.datamodels.cloning.Oas30ModelClonerVisitor";
Oas30ModelClonerVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




